import { observable, runInAction, action } from "mobx";
import { ViewModelBase, FieldType } from "@shoothill/core";
import { SpillKitModel } from "./SpillKitModel";

export class SpillKitViewModel extends ViewModelBase<SpillKitModel> {
    constructor(model = new SpillKitModel()) {
        super(model);
        this.setDecorators(SpillKitModel);
    }
    @action
    public radioChanged = async (value: string, fieldName: string, editable: boolean) => {
        if (!editable) return;
        this.model[fieldName] = value;
        await this.isFieldValid(fieldName as any, value);
    };
    public async isFieldValid(fieldName: keyof FieldType<SpillKitModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
